import { Suspense, useEffect, useState } from "react";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";
import { Box, Grid2, Paper } from "@mui/material";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { useForm } from "react-hook-form";
import InputSwitch from "../../../../components/inputs/yup/materialui/inputSwitch";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { selectorTransversal } from "../../../../dtos/selector";
import { AxiosResponse } from "axios";
import { getValoresDominio } from "../../../../services/servicesDominio";
import { Dominios, StatusCode, TipoFuncionalidad } from "../../../../utils/enums";
import { descargarArchivosProcesosMasivos } from "../../../detalleMutuo/services/servicesReportes";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { getRecaudadores } from "../../../dividendo/services/servicesRecaudacionIndividual";
import { getEmisor } from "../service/servicePM";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { Emisor } from "../models/generarArchivoProcesosMasivos";
import { Recaudador } from "../../../dividendo/models/recaudador";
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";


export interface GenerarArchivoProcesosMasivos {
    fechaEmision: Date;
    empresaCobranza: string;
    emisor: string;
    esAdmin: boolean;
}
function GenerarProcesosMasivos() {

const schema = yup.object({
  fechaEmision: yup.date().required("La fecha es requerida"),
  empresaCobranza: yup.string().required("La empresa cobranza es requerida"),
  emisor: yup.string().required("El emisor es requerido"),
  esAdmin: yup.boolean().required("El campo es requerido"),
});

  const {
    formState: { errors },
    control,
    handleSubmit,
  } = useForm<GenerarArchivoProcesosMasivos>({
    mode: "onBlur",
    resolver: yupResolver(schema),
    defaultValues: {
      fechaEmision: new Date(), 
      empresaCobranza: "",
      emisor: "",
      esAdmin: true, 
    },
  });

    const [options, setOptions] = useState<selectorTransversal[]>([]);
    const [optionsEmisor, setOptionsEmisor] = useState<selectorTransversal[]>([]);

    const tipoEmpresaCobranza = async () => {

          const resp: AxiosResponse<ListResponseDto<Recaudador>> = await getRecaudadores();
               if (resp.status === StatusCode.Ok) {
                   const data: Recaudador[] = await resp.data.items;
                   const options = data.map((m: any) => ({
                       label: m.nombre,
                       value: m.rut,
                   })); setOptions(options);
               }
        return;
    }

    const tipoEmisor = async () => {
        const resp: AxiosResponse<ListResponseDto<Emisor>> = await getEmisor()
        if (resp.status === StatusCode.Ok) {
            const data: Emisor[] = await resp.data.items;
            const options = data.map((m: any) => ({
                label: m.nombre,
                value: m.rut,
            })); setOptionsEmisor([{ label: "Todos", value: "-1" }, ...options]);
        }
        return;
    }



    useEffect(() => {
        const inicializar = async () => {
            await tipoEmpresaCobranza();
            await tipoEmisor();

        };

        inicializar();
    }, []);


    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Cobranzas', url: `/cobranzas` },
        { label: 'Archivo cobranza externa', active: true },
    ]

    const onSubmit = async (data: GenerarArchivoProcesosMasivos) => {
        await descargarArchivosProcesosMasivos(data);

    }

    return (
        <Suspense>
            <Breadcrumb items={breadcrumbItems} />
            <Box sx={{ mt: 2 }}>
                <Paper elevation={3} sx={{ p: 3 }}>
                    <Suspense>
                        <CustomAccordion
                            title='Filtros'
                            expandedDefault
                        >
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Grid2 container spacing={2}>
                                    <Grid2 size={3}>
                                        <InputFecha
                                            name="fechaEmision"
                                            control={control}
                                            label="Fecha"
                                             error={errors.fechaEmision}
                                        />
                                    </Grid2>
                                    <Grid2 size={3}>
                                        <InputSelect
                                            name="empresaCobranza"
                                            control={control}
                                            label="Empresa cobranza"
                                            options={options}
                                            error={errors.empresaCobranza}

                                        />
                                    </Grid2>
                                    <Grid2 size={3}>
                                        <InputSelect
                                            name="emisor"
                                            control={control}
                                            label="Emisor"
                                            options={optionsEmisor}
                                            error={errors.emisor}

                                        />
                                    </Grid2>
                                    <Grid2 size={3} sx={{ mt: 3 }}>
                                        <InputSwitch
                                            name="esAdmin"
                                            control={control}
                                            label="Es administrado"
                                            error={errors.esAdmin}
                                        />
                                    </Grid2>

                                    <Grid2 container justifyContent="flex-end" alignItems="center" sx={{ mt: 2 }}>
                                        <Grid2>
                                            <PermissionGuard permissions={[TipoFuncionalidad.Cobranza_adm]}>
                                            <MButton
                                                type="submit"
                                                variant="contained"
                                                startIcon={<SummarizeTwoToneIcon />}
                                            >
                                                Generar archivo
                                            </MButton>
                                            </PermissionGuard>  
                                        </Grid2>
                                    </Grid2>

                                </Grid2>
                            </form>
                        </CustomAccordion>
                    </Suspense>
                </Paper>


            </Box>

        </Suspense>

    );

};
export default GenerarProcesosMasivos;